import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Cookies from '@/cookies';
import messages from '@/lang/messages';
import { availableLanguages, defaultLanguage } from '@/config';

Vue.use(VueI18n);

const getLocale = () => {
    if (Cookies.read('user-locale')) {
        console.log('cookie override user-locale = ', Cookies.read('user-locale'));
        return Cookies.read('user-locale');
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('lang')) {
        if (availableLanguages.includes(urlParams.get('lang'))) {
            console.log('language via query param', urlParams.get('lang'));
            return urlParams.get('lang');
        }
    }
    const language = (window.navigator.userLanguage || window.navigator.language).substring(0, 2);
    console.log('window.navigator.language = ', language);
    return availableLanguages.includes(language.toLowerCase())
        ? language
        : defaultLanguage;
};

export default new VueI18n({
    locale: getLocale(),
    fallbackLocale: defaultLanguage,
    silentTranslationWarn: true,
    messages,
});
